var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLink = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0235 7C18.4006 7 19.5743 7.49844 20.5446 8.49533C21.5149 9.46106 22 10.6293 22 12C22 13.3707 21.5149 14.5545 20.5446 15.5514C19.5743 16.5171 18.4006 17 17.0235 17H12.9859V15.0841H17.0235C17.8685 15.0841 18.5884 14.7882 19.1831 14.1963C19.8091 13.5732 20.1221 12.8411 20.1221 12C20.1221 11.1589 19.8091 10.4424 19.1831 9.85047C18.5884 9.22741 17.8685 8.91589 17.0235 8.91589H12.9859V7H17.0235ZM8.00939 12.9813V11.0187H15.9906V12.9813H8.00939ZM4.76995 9.85047C4.17527 10.4424 3.87793 11.1589 3.87793 12C3.87793 12.8411 4.17527 13.5732 4.76995 14.1963C5.39593 14.7882 6.13146 15.0841 6.97653 15.0841H11.0141V17H6.97653C5.59937 17 4.42567 16.5171 3.4554 15.5514C2.48513 14.5545 2 13.3707 2 12C2 10.6293 2.48513 9.46106 3.4554 8.49533C4.42567 7.49844 5.59937 7 6.97653 7H11.0141V8.91589H6.97653C6.13146 8.91589 5.39593 9.22741 4.76995 9.85047Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-link.40dbf25390108fb98d9863e69e3b2087.svg";